import { Laptop, Rocket, Smile } from "lucide-react";
const steps = [{
  id: "step-1",
  icon: "laptop",
  title: "1. Initial Inquiry",
  description: "Submit your project details through our secure digital portal. We analyze your specific needs to identify the most compatible financing partners."
}, {
  id: "step-2",
  icon: "rocket",
  title: "2. Strategic Matching",
  description: "We bridge the gap by connecting you with our vetted network of financing platforms. We are the expert connection, not the lender."
}, {
  id: "step-3",
  icon: "smile",
  title: "3. Direct Funding",
  description: "Finalize your application directly with the chosen provider. Upon approval, capital is deployed to bring your vision to life."
}];
export default function ApplicationRoadmap() {
  const renderIcon = (iconName: string) => {
    switch (iconName) {
      case "laptop":
        return <Laptop className="size-10" />;
      case "rocket":
        return <Rocket className="size-10" />;
      case "smile":
        return <Smile className="size-10" />;
      default:
        return null;
    }
  };
  return <section data-section-id="110528" id="how-the-connection-works" className="w-full bg-background py-16 px-4 md:px-8">
      <div className="mx-auto max-w-7xl text-center">
        <h2 className="mb-2 text-[40px] font-bold text-primary tracking-tighter uppercase">
          HOW THE CONNECTION WORKS
        </h2>
        <p className="mb-12 text-[18px] font-medium text-muted-foreground max-w-2xl mx-auto">
          Simplifying the bridge between homeowners, contractors, and expert financing solutions.
        </p>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-3 md:gap-12">
          {steps.map((step, i) => <div key={step.id} data-index={i} className="flex flex-col items-center text-center">
              <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-white/60 text-primary backdrop-blur-md border border-white/30 shadow-xl">
                {renderIcon(step.icon)}
              </div>
              <h3 className="mb-3 text-[22px] font-bold text-primary tracking-tight">
                {step.title}
              </h3>
              <p className="text-[16px] leading-relaxed text-muted-foreground font-medium">
                {step.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}